/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import { useMenu } from '../../contexts/SiteContext';
import SectionsMenu from '../menus/SectionsMenu';
import Image from '../partials/Image';

import styles from '../../../styles/headers/edition.module.scss';

const propTypes = {
    page: AppPropTypes.page,
    className: PropTypes.string,
    children: PropTypes.node,
};

const defaultProps = {
    page: null,
    className: null,
    children: null,
};

const EditionHeader = ({ page, className, children }) => {
    const { title: pageTitle = null, edition = null, parent = null, menu = null } = page || {};
    const { poster = null } = edition || {};
    const { main } = useMenu();
    const section = parent || page;
    const menuItems = menu !== null ? { items: menu } : null;

    const { items = null } =
        menuItems !== null
            ? menuItems
            : main.find(({ page: pageId }) => section !== null && pageId === section.id) || {};

    const sectionMenuItems =
        items !== null
            ? (items || []).map((item) => ({ ...item, active: item.page === page.id }))
            : null;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {items !== null && items.length > 0 ? <SectionsMenu items={sectionMenuItems} /> : null}
            <div className={styles.splash}>
                {pageTitle !== null ? <h1 className={styles.title}>{pageTitle}</h1> : null}
                {poster !== null && (
                    <div className={styles.posterContainer}>
                        <Image className={styles.poster} media={poster} fit />
                    </div>
                )}
                {children}
            </div>
        </div>
    );
};
EditionHeader.propTypes = propTypes;
EditionHeader.defaultProps = defaultProps;

export default EditionHeader;
